import { ErrorHandler, Injectable, inject } from "@angular/core";
import { ChunkLoadRecoveryService } from "../_services/chunk-load-recovery.service";

/**
 * Global error handler that gives ChunkLoadRecoveryService first refusal on
 * every unhandled error, then defers to Angular's default behaviour.
 *
 * Needed for two reasons: it is the only path for the dynamic imports the
 * router does not own — the import("xlsx") calls in excel.service.ts,
 * crud-table.component.ts, user-dataset.service.ts and
 * admin-dataimport-submission.component.ts — and a router-owned lazy route
 * failure can *also* reach here for the same failure it already reported as
 * a NavigationError through withNavigationErrorHandler in app.module.ts.
 * Both call the same handle(), and its reloadScheduled flag — not the
 * sessionStorage guard alone — is what makes that double delivery harmless.
 */
@Injectable()
export class ChunkLoadErrorHandler extends ErrorHandler {
  private recovery = inject(ChunkLoadRecoveryService);

  override handleError(error: unknown): void {
    if (this.recovery.handle(error)) {
      return;
    }
    super.handleError(error);
  }
}
